<template>
	<section class="min-h-screen flex items-center justify-center px-4">
		<slot />
	</section>
</template>

<script setup lang="ts">
// Login layout - no auth middleware needed
</script>
